var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panel",
    { attrs: { disabled: _vm.disabled } },
    [
      _c("v-expansion-panel-header", {
        attrs: { den: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ open }) {
              return [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c("span", { staticStyle: { "margin-top": "5px" } }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                    _c("v-spacer"),
                    _c("v-fade-transition", [
                      open
                        ? _c(
                            "span",
                            { staticStyle: { display: "inline-flex" } },
                            [
                              _c("v-divider", {
                                staticClass: "mx-1",
                                attrs: { vertical: "" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "v-expansion-panel-content",
        [
          _c("v-divider"),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "3", md: "3" } },
                [
                  _c("r-range", {
                    attrs: { model: _vm.value.level, label: "Level:" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.value, "level", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-3", attrs: { dense: "" } },
            [
              _c("r-guard-rules", {
                attrs: {
                  items: _vm.value.allow,
                  anyof: _vm.value.allowAnyOf,
                  title: "Allow",
                },
                on: {
                  "update:items": function ($event) {
                    return _vm.$set(_vm.value, "allow", $event)
                  },
                  "update:anyof": function ($event) {
                    return _vm.$set(_vm.value, "allowAnyOf", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c("v-row", { attrs: { dense: "" } }, [_c("v-divider")], 1),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c("r-guard-rules", {
                attrs: {
                  items: _vm.value.block,
                  anyof: _vm.value.blockAnyOf,
                  title: "Block",
                },
                on: {
                  "update:items": function ($event) {
                    return _vm.$set(_vm.value, "block", $event)
                  },
                  "update:anyof": function ($event) {
                    return _vm.$set(_vm.value, "blockAnyOf", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c("v-row", { attrs: { dense: "" } }, [_c("v-divider")], 1),
          _c(
            "v-row",
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  !_vm.isEmptyArray(_vm.value.offersAllow)
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "my-1 fill-width",
                          attrs: { small: "", color: "success" },
                          on: { click: _vm.onOffersAllow },
                        },
                        [_vm._v(" Offers Allow ")]
                      )
                    : _c(
                        "v-btn",
                        {
                          staticClass: "my-1 fill-width",
                          attrs: { small: "", outlined: "", color: "primary" },
                          on: { click: _vm.onOffersAllow },
                        },
                        [_vm._v(" Offers Allow ")]
                      ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  !_vm.isEmptyArray(_vm.value.offersBlock)
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "my-1 fill-width",
                          attrs: { small: "", color: "success" },
                          on: { click: _vm.onOffersBlock },
                        },
                        [_vm._v(" Offers Block ")]
                      )
                    : _c(
                        "v-btn",
                        {
                          staticClass: "my-1 fill-width",
                          attrs: { small: "", outlined: "", color: "primary" },
                          on: { click: _vm.onOffersBlock },
                        },
                        [_vm._v(" Offers Block ")]
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  _c("r-avatar-dropdown", {
                    attrs: { model: _vm.value.avatar, clearable: true },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.value, "avatar", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.value.avatar
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-avatar-status", {
                        attrs: { model: _vm.value.avatarStatus },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.value, "avatarStatus", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  _c("r-product-dropdown", {
                    attrs: { model: _vm.value.product, clearable: true },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.value, "product", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.value.product
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-product-status", {
                        attrs: { model: _vm.value.productStatus },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.value, "productStatus", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("r-smart-offer-table-dialog", { ref: "smart-offer-table-dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }